import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { ConfirmModalModule } from '@app/shared/components/confirm-modal/confirm-modal.module';
import { BinaSharedModule } from '@shared/bina-shared/bina-shared.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import {
  HtsAssistantComposerComponent,
  HtsAssistantDrawerComponent,
  HtsAssistantHistoryLinkComponent,
  HtsAssistantMessageComponent,
  HtsAssistantResultCardComponent,
  HtsAssistantThinkingComponent,
  HtsAssistantThreadComponent,
  HtsLineStatusChipComponent,
} from './components';

/**
 * Classification assistant (#13383 / #13384). Must NOT import EsMutualModule (it imports this module): the es-mutual line
 * panel of the Validate view is rendered through `[dynamic-component]` from a `Type` the host passes in.
 */
@NgModule({
  declarations: [
    HtsAssistantDrawerComponent,
    HtsAssistantThreadComponent,
    HtsAssistantMessageComponent,
    HtsAssistantThinkingComponent,
    HtsAssistantResultCardComponent,
    HtsAssistantComposerComponent,
    HtsLineStatusChipComponent,
    HtsAssistantHistoryLinkComponent,
  ],
  imports: [CommonModule, TranslateModule, NzToolTipModule, BinaSharedModule, DirectivesModule, ConfirmModalModule],
  exports: [HtsAssistantDrawerComponent, HtsLineStatusChipComponent, HtsAssistantHistoryLinkComponent],
})
export class HtsAssistantModule {}
